import { Injectable } from "@angular/core";
import {
  PRIMITIVE,
  ServiceMessageBrokerFactory,
  ServiceMessageBroker,
} from "shared/provider-webworker";

import { SalesGroupLookupService } from "./SalesGroupLookupService";
import { PrimaryLookupService } from "../../impl/PrimaryLookupService";
import { ISalesGroupPromiseLookupService } from "../ISalesGroupPromiseLookupService";
import { BaseLookupService } from "../../impl/BaseLookupService";
import { PromiseLookupService } from "../../impl/PromiseLookupService";

import { CubiqWorker } from "../../../worker/CubiqWorker";

import * as CubiqTS from "shared/cubiq-model-multi-asset";
import { LoggerService } from "@bfx/logger";
const logger = LoggerService.for(__dirname);

@Injectable()
export class SalesGroupPrimaryLookupService
  extends PrimaryLookupService<string, CubiqTS.SalesGroupImpl>
  implements ISalesGroupPromiseLookupService
{
  constructor(
    protected base: SalesGroupLookupService,
    protected factory: ServiceMessageBrokerFactory,
    protected cubiqWorker: CubiqWorker,
  ) {
    super(base, factory, CubiqTS.SalesGroupImpl, cubiqWorker, "SalesGroupImpl");

    cubiqWorker.isAuth(`${this.constructor.name}`).then(
      () => {
        let salesGroupsObservable = cubiqWorker.primeStaticData<CubiqTS.SalesGroupImpl>(
          CubiqTS.SalesGroupImpl.name,
        );

        salesGroupsObservable.subscribe(
          (salesGroups: CubiqTS.SalesGroupImpl[]) => {
            this.base.prime(salesGroups);
          },
          (error: Error) => {
            console.debug("CurrencyPair prime failed");
            this._primed.reject(error);
          },
          () => {
            this._primed.resolve(true);
          },
        );
      },
      (reason) => {
        console.debug("SalesGroupPrimaryLookupService: Failed to prime: " + reason);

        this._primed.resolve(false);
      },
    );

    this.broker.registerMethod(
      "getSalesGroup",
      [PRIMITIVE],
      this.getSalesGroup.bind(this),
      this.VALUE,
    );
  }

  getSalesGroup(id: CubiqTS.Long): Promise<CubiqTS.SalesGroupImpl> {
    return new Promise<CubiqTS.SalesGroupImpl>((res, rej) => {
      res(this.base.getSalesGroup(id));
    });
  }
}
